import React, { Component } from 'react';
import styles from './stylesheets/ShowIntro.module.css';
import {RightArrow} from '../Svg/index'

export class ShowIntro extends Component {
    render() {
        return (
            <div className={styles.showIntro}>
                <div className={styles.introBtn}>
                    <a href="">SHOW INTRO</a>
                </div>
                <div className={styles.newReferral}>
                    <div className={styles.joinUsBtn}>
                        <div className={styles.arrowCont}>
                            <RightArrow></RightArrow>
                        </div>
                        <div className={styles.joinNowPara}>
                            <p>Request Early Access</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ShowIntro

